import React, { useEffect, useState } from "react";
import SignUp from "./mainSignupForm";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import SignUpIdentity from "./sign up identity";
import { useUser } from "../../context/UserContext";
import httpServices from "../../services/httpServices";
import { toast } from "react-toastify";
import CryptoJS from 'crypto-js';


const commonSchema = {
  name: Yup.string()
    .required("Name is required")
    .matches(/^[a-zA-Z\s]+$/, "Name can only contain letters and spaces"),
  email: Yup.string()
    .required("Email is required")
    .email("Please enter a valid email address"),

  password: Yup.string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters long")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/\d/, "Password must contain at least one number")
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      "Password must contain at least one special character"
    ),

  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required"),
  userType: Yup.number().required("User type is required"),
};

const individualSchema = Yup.object().shape({
  ...commonSchema,

  phoneNumber: Yup.number()
    .typeError("Phone number must be a number")
    .required("Phone number is required")
    .min(1000000000, "Phone number must be at least 10 digits")
    .max(9999999999, "Phone number cannot exceed 10 digits"),

  description: Yup.string()
    .required("Description is required")
    .max(500, "Description must not exceed 500 characters"),

  location: Yup.string()
    .required("Location is required")
    .max(100, "Location must not exceed 100 characters"),

  countryCode: Yup.number()
    .default(91)
    .typeError("Country code must be a number")
    .required("Country code is required"),

  // country: Yup.string()
  //   .require("Country is required")
  //   .max(100, "Country must not exceed 100 characters"),
  // emailVerified: Yup.boolean().optional(
  //   "Email verification status is required"
  // ),

  // phoneNumberVerified: Yup.boolean().(
  //   "Phone number verification status is required"
  // ),
  businessHubName: Yup.string()
    .required("Business hub name is required")
    .max(100, "Business hub name must not exceed 100 characters"),

  // jobTitle: Yup.string()
  //   .required("Job title is required")
  //   .max(100, "Job title must not exceed 100 characters"),
});

const corporateSchema = Yup.object().shape({
  ...commonSchema, // Spread common fields
  tanNumber: Yup.string()
    .matches(
      /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/,
      "TAN number must be in the format of 4 alphabets, followed by 5 digits, and ending with 1 alphabet."
    )
    .required("TAN number is required"),

  jobTitle: Yup.string()
    .required("Job title is required")
    .max(100, "Job title must not exceed 100 characters"),
});

const MainRegForm = () => {
  const navigate = useNavigate();
  const { user, isSimpleUser } = useUser();
  console.log("user from sign up", user);

  const [personType, setPersonType] = useState("individual");
  const [step, setStep] = useState(0);

  useEffect(() => {
    if (user && isSimpleUser) {
      navigate("/events");
    } else if (user) {
      navigate("/");
    }
  }, [personType, user]);

  const methods = useForm({
    resolver: yupResolver(
      personType === "individual" ? individualSchema : corporateSchema
    ),
  });

  const onSubmit = async (data) => {
    const toastId = toast.loading(`Creating your account...`);
    const { confirmPassword, ...registerData } = data;
    console.log(registerData);

    const hashedPassword = CryptoJS.MD5(data.password).toString(CryptoJS.enc.Base64);

    registerData.password = hashedPassword

    // Replace the plain password with the encrypted one

    try {
      const { response, error, loading } = await httpServices.post(
        "/users/register",
        registerData
      );

      if (error) {
        throw error;
      }

      if (response.status === 201) {
        toast.update(toastId, {
          render: "Registration successful",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });

        navigate("/login");
      }
    } catch (error) {
      toast.update(toastId, {
        render: error?.response?.data?.message || "Something went wrong",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      toast.dismiss(toastId);
    }
  };

  const onError = (errors) => {
    if (
      !errors.email &&
      !errors.password &&
      !errors.confirmPassword &&
      !errors.terms
    ) {
      setStep(1);
    }
    console.log(errors);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit, onError)}>
        {step === 0 && <SignUp />} {/* First step: sign-up form */}
        {step === 1 && (
          <SignUpIdentity setUserType={setPersonType} setStep={setStep} />
        )}
      </form>
    </FormProvider>
  );
};

export default MainRegForm;

